module.exports = __webpack_public_path__ + "img/img_manual3_2.1a157575.jpg";